<template>
  <div class="main-cargo-statistics">
    <div class="cargo-statistics-sum">
      <el-row style="margin-top: 50px">
        <el-col :span="4">{{$lang('运单票数')}}</el-col>
        <el-col :span="4">{{$lang('回单合计数')}}</el-col>
        <el-col :span="4">{{$lang('计费重量')}}</el-col>
        <el-col :span="4">{{$lang('已签收合计数')}}</el-col>
        <el-col :span="4">{{$lang('未签收合计数')}}</el-col>
        <el-col :span="4">{{$lang('运费合计数')}}</el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="4">{{totalResult.waybillNum}}</el-col>
        <el-col :span="4">{{totalResult.receiptNum}}</el-col>
        <el-col :span="4">{{totalResult.packageChargeWeight}}</el-col>
        <el-col :span="4">{{totalResult.signNum}}</el-col>
        <el-col :span="4">{{totalResult.notSignNum}}</el-col>
        <el-col :span="4">{{totalResult.totalFreight}}</el-col>
      </el-row>
    </div>
    <div class="form-cargo-statistics">
      <el-form :inline="true" :model="searchParam" class="demo-form-inline">
        <el-form-item prop="date"  :label="$lang('揽收时间')">
          <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="orderNumberType" v-show="activeName ==='detail'">
            <el-select v-model="searchParam.orderNumberType" class="order-number-select">
              <el-option :label="$lang('运单号')" value="1"></el-option>
              <el-option :label="$lang('订单号')" value="2"></el-option>
              <el-option :label="$lang('回单号')" value="3"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item style="margin-left: -15px;" prop="orderNumber" v-show="activeName ==='detail'">
          <base-input-tag
              v-model="searchParam.orderNumber"
              :placeholder="$lang('最多可查100条')"
              clearBtnVisible
              addTagOnBlur
              ref="orderNumberRef"
              class="cms-input-tag"
          >
          </base-input-tag>
        </el-form-item>
        <el-form-item prop="waybillStatusCode"  :label="$lang('运单状态')" v-show="activeName ==='detail'">
          <el-select v-model="searchParam.waybillStatusCode" clearable>
            <el-option
                v-for="item in getDictList"
                :key="item.value"
                :label="item.label"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isRefund"  :label="$lang('退转件')" v-show="activeName ==='detail'">
          <el-select v-model="searchParam.isRefund" class="order-number-select" clearable>
            <el-option :label="$lang('是')" value="1"></el-option>
            <el-option :label="$lang('否')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: flex-end;">
          <el-button type="primary" :loading="loading" icon="el-icon-search" @click="onSubmit">{{$lang('查询')}}</el-button>
          <el-button @click="reset" icon="el-icon-delete" >{{$lang('清空')}}</el-button>
          <el-button @click="exportRecord" :loading="loading" icon="el-icon-download">{{$lang('导出')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-cargo-statistics">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$lang('汇总')" name="sum">
          <JmsTableScroll
              class="tableClass"
              ref="sumTable"
              :option="sumListOpt"
              :data="sumTableData"
              :page="page"
              :table-loading="loading"
              @size-change="sizeChange"
              @current-change="currentChange"
          >
          </JmsTableScroll>
        </el-tab-pane>
        <el-tab-pane :label="$lang('明细')" name="detail">
          <JmsTableScroll
              :option="detailListOpt"
              :data="detailTableData"
              :page="page"
              :table-loading="loading"
              @size-change="sizeChange"
              @current-change="currentChange"
             >
          </JmsTableScroll>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import { commonFun } from '@utils/common'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { pageCargoStatisticsSum, pageCargoStatisticsDetail, exportAsync } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'CargoStatistics',
  props: {
    tabPosition: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    JmsTableScroll,
  },
  data() {
    return {
      loading: false,
      totalResult: {
        waybillNum: 0,
        notSignNum: 0,
        signNum: 0,
        packageChargeWeight: 0.00,
        receiptNum: 0,
        totalFreight: 0.00,
      },
      page: {
        // 分页配置
        current: 1,
        size: 50,
        total: 0,
        pageSizes: [50, 100, 200, 500],
      },
      sumTableData: [],
      detailTableData: [],
      getDictList: [],
      activeName: 'sum',
      searchParam: {
        date: [],
        orderNumberType: '1',
      },
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
          return time.getTime() < minTime || time.getTime() > maxTime
        },
      },
    }
  },
  watch: {
    tabPosition(val) {
      if (val && this.$refs.sumTable) {
        this.$refs.sumTable.$refs.table.doLayout()
      }
    },
  },
  methods: {
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.onSubmit()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.onSubmit()
    },
    handleClick() {
      console.log(this.activeName)
      this.onSubmit()
    },
    async exportRecord() {
      if (this.validateParam()) {
        return
      }
      this.loading = true
      if (this.activeName === 'sum') {
        this.searchParam.fileCode = '1'
      }
      if (this.activeName === 'detail') {
        this.searchParam.fileCode = '2'
        this.setNumber()
      }
      const { code, data, msg } = await exportAsync(this.searchParam)
      this.loading = false
      if (code === RESPONSE_SUCCESS && data) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        return this.$message.error(this.$lang(msg))
      }
    },
    reset() {
      this.setDefaultDate()
      this.searchParam.orderNumberType = '1'
      this.searchParam.orderNumber = []
      this.searchParam.waybillStatusCode = ''
      this.searchParam.isRefund = ''
    },
    validateParam() {
      console.log(this.searchParam)
      const { beginDate, endDate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTimeLong = new Date(beginDate).getTime()
      const endTimeLong = new Date(endDate).getTime()
      if (endTimeLong - startTimeLong > space) {
        return this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
      }
      // 处理运单编号
      if (this.searchParam.orderNumber && this.searchParam.orderNumber.length !== 0) {
        if (this.searchParam.orderNumber.length > 100) {
          return this.$message.warning(this.$lang('单号请勿超过100条'))
        }
      }
    },
    setNumber() {
      if (this.searchParam.orderNumberType === '1') {
        this.searchParam.waybillNo = this.searchParam.orderNumber
        this.searchParam.orderNo = null
        this.searchParam.receiptNo = null
      }
      if (this.searchParam.orderNumberType === '2') {
        this.searchParam.orderNo = this.searchParam.orderNumber
        this.searchParam.receiptNo = null
        this.searchParam.waybillNo = null
      }
      if (this.searchParam.orderNumberType === '3') {
        this.searchParam.receiptNo = this.searchParam.orderNumber
        this.searchParam.orderNo = null
        this.searchParam.waybillNo = null
      }
    },
    async onSubmit() {
      if (this.validateParam()) {
        return
      }
      this.loading = true
      this.searchParam.current = this.page.current
      this.searchParam.size = this.page.size
      if (this.activeName === 'sum') {
        const { code, data, msg } = await pageCargoStatisticsSum(this.searchParam)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.sumTableData = data.records
          this.totalResult = data.totalResult
          this.page.current = data.current
          this.page.total = data.total
          this.$nextTick(() => {
            this.$refs.sumTable.$refs.table.doLayout()
          })
        } else {
          return this.$message.error(this.$lang(msg))
        }
      }
      if (this.activeName === 'detail') {
        this.setNumber()
        const { code, data, msg } = await pageCargoStatisticsDetail(this.searchParam)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.detailTableData = data.records
          if (this.detailTableData && this.detailTableData.length > 0) {
            for (let i = 0; i < this.detailTableData.length; i++) {
              this.detailTableData[i].isCouponCode = this.$lang(this.detailTableData[i].isCouponCode)
              this.detailTableData[i].isReceiptNo = this.$lang(this.detailTableData[i].isReceiptNo)
              this.detailTableData[i].isSign = this.$lang(this.detailTableData[i].isSign)
              this.detailTableData[i].isRefund = this.$lang(this.detailTableData[i].isRefund)
            }
          }

          this.page.current = data.current
          this.page.total = data.total
        } else {
          this.$message.error(this.$lang(msg))
        }
      }
    },
    // 选择日期
    selectDate() {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.beginDate = start
        this.searchParam.endDate = end
      }
    },
    setDefaultDate() {
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const firstDay = commonFun.formatDate(firstDayOfMonth)
      this.searchParam.date = [firstDay, commonFun.formatDate(today)]
      this.selectDate()
    },
  },
  async created() {
    const dictList = commonFun.getDict('NWM_131')
    dictList.then(e => {
      this.getDictList = e.map(element => {
        return {
          ...element,
          value: element.code,
          label: element.name,
        }
      })
    })
    this.setDefaultDate()
    this.onSubmit()
  },
  computed: {
    sumListOpt() {
      return {
        tableHeight: '400',
        border: true,
        selection: false,
        menu: false,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '揽收时间',
            prop: 'dateCode',
          },
          {
            label: '运单票数',
            prop: 'waybillNum',
          },
          {
            label: '回单合计数',
            prop: 'receiptNum',
          },
          {
            label: '计费重量',
            prop: 'packageChargeWeight',
          },
          {
            label: '已签收合计数',
            prop: 'signNum',
          },
          {
            label: '未签收合计数',
            prop: 'notSignNum',
          },
          {
            label: '运费合计数',
            prop: 'totalFreight',
          },
        ],
      }
    },
    detailListOpt() {
      return {
        tableHeight: '400',
        border: true,
        selection: false,
        menu: false,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '客户订单号',
            prop: 'customerOrderId',
          },
          {
            label: '运单号',
            prop: 'waybillNo',
          },
          {
            label: '开单时间',
            prop: 'inputTime',
          },
          {
            label: '件数',
            prop: 'packageNumber',
          },
          {
            label: '重量',
            prop: 'packageChargeWeight',
          },
          {
            label: '体积',
            prop: 'packageTotalVolume',
          },
          {
            label: '运单结算方式',
            prop: 'settlementName',
          },
          {
            label: '总运费',
            prop: 'totalFreight',
          },
          {
            label: '运单费用',
            prop: 'freight',
          },
          {
            label: '保险费',
            prop: 'insuredFee',
          },
          {
            label: '回单费',
            prop: 'receiptFee',
          },
          {
            label: '其他费',
            prop: 'otherFee',
          },
          {
            label: '入仓费',
            prop: 'wareHouseFee',
          },
          {
            label: '包材费',
            prop: 'packageCost',
          },
          {
            label: '是否回单',
            prop: 'isReceiptNo',
          },
          {
            label: '回单号',
            prop: 'receiptNo',
          },
          {
            label: '回单第三方单号',
            prop: 'releationWaybillNo',
          },
          {
            label: '回单第三方名称',
            prop: 'receiptRebackName',
          },
          {
            label: '回单转出时间',
            prop: 'receiptCreateTime',
          },
          {
            label: '回单照片',
            prop: 'imageUrl',
          },
          {
            label: '签收状态',
            prop: 'isSign',
          },
          {
            label: '签收时间',
            prop: 'signTime',
          },
          {
            label: '寄件网点',
            prop: 'pickNetworkName',
          },
          {
            label: '揽件城市',
            prop: 'originName',
          },
          {
            label: '目的网点',
            prop: 'dispatchNetworkName',
          },
          {
            label: '签收城市',
            prop: 'signCity',
          },
          {
            label: '收件人',
            prop: 'receiverName',
          },
          {
            label: '收件电话',
            prop: 'receiverMobilePhone',
          },
          {
            label: '收件人省区',
            prop: 'receiverProvinceName',
          },
          {
            label: '收件人详细地址',
            prop: 'receiverDetailedAddress',
          },
          {
            label: '是否优惠券',
            prop: 'isCouponCode',
          },
          {
            label: '优惠券',
            prop: 'couponCode',
          },
          {
            label: '优惠金额',
            prop: 'couponAmount',
          },
          {
            label: '是否转退件',
            prop: 'isRefund',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.cargo-statistics-sum{
  border: 1px solid black;
  border-radius: 20px;
  width: 90%;
  height: 150px;
  text-align: center;
  margin-left: 50px;
}
.main-cargo-statistics{
  font-weight: 500;
  color: #666;
}
.form-cargo-statistics{
  margin-left: 50px;
  margin-top: 20px;
}
.table-cargo-statistics{
  margin-left: 50px;
}
.order-number-select >>> .el-input{
  width: 90px !important;
}

</style>
